import { Badge } from '../../ui';

interface MfaStatusBadgeProps {
  enabled: boolean;
  required?: boolean;
  overdue?: boolean;
}

/**
 * Compact badge summarising a user's MFA state. The order of precedence
 * is: overdue (red) → required-but-missing (warning) → enabled (success) →
 * disabled (neutral). The admin portal uses this in user lists; the
 * security settings page shows a fuller card.
 */
export function MfaStatusBadge({ enabled, required, overdue }: MfaStatusBadgeProps) {
  if (overdue && !enabled) {
    return <Badge tone="danger">MFA overdue</Badge>;
  }
  if (required && !enabled) {
    return <Badge tone="warning">MFA required</Badge>;
  }
  if (enabled) {
    return <Badge tone="success">MFA enabled</Badge>;
  }
  return <Badge tone="neutral">MFA off</Badge>;
}
